import { fromJS } from 'immutable';

import {
    REQUEST_SUGGEST, SUCCESS_SUGGEST, FAILURE_SUGGEST,
    CLEAR_SUGGESTS, SET_KEYWORD, CLEAR_KEYWORD, SET_SELECTED
  } from './actions';

// The initial state of the App
const initialState = fromJS({
   
  keyword: '',
  suggests: [],
  status: '',
  error: false,
  selected: null,

});

function searchReducer(state = initialState, action) {
  switch (action.type) {

    case REQUEST_SUGGEST:
      return state
        .set('status', 'working')
        .set('error', false);

    case SUCCESS_SUGGEST:
      console.log( 'action', action.payload)
      return state
        .set('status', 'done')
        .set('error', false)
        .set('suggests', action.payload.data);

    case FAILURE_SUGGEST:
      return state
      .set('status', 'done')
      .set('error', true);

    case CLEAR_SUGGESTS:
      return state
        .set('suggests', initialState.getIn(['suggests']).slice());

    case SET_KEYWORD:
      return state
        .set('keyword', action.payload);

    case CLEAR_KEYWORD:
      return state
        .set('keyword', initialState.getIn(['keyword']));
        
    case SET_SELECTED:
      return state
        .set('selected', action.payload);

    default:
      return state;
  }
}
  


export default searchReducer;



// WEBPACK FOOTER //
// ./src/redux/searchads/reducer.js